export default __webpack_public_path__ + "assets/column_widget.0ece643239748a53e98a51b7e03b8684.svg";